import axios from "axios";
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import {refreshAccessToken} from "./loginApiClient";
import {LocalStorageUtil, SessionStorageUtil} from "./localStorageUtil";

const AUTHENTICATION_KEY = "ce-a";
const IMPERSONATION_KEY = "ce-impersonation";

axios.interceptors.request.use(config => {

    let token = SessionStorageUtil.getObj(IMPERSONATION_KEY);
    if (!token) {
        token = LocalStorageUtil.getPropertyValue(AUTHENTICATION_KEY, "access_token");
    }
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
});

const refreshAuthLogic = async (failedRequest) => {
    const [err, res] = await refreshAccessToken();
    if (err) {
        LocalStorageUtil.setObj(AUTHENTICATION_KEY, null);
        SessionStorageUtil.removeObj(IMPERSONATION_KEY); // clear impersonation on auth failure
        window.location = "/";
        return Promise.reject(err);
    } else {
        LocalStorageUtil.setObj(AUTHENTICATION_KEY, res.data);
        failedRequest.response.config.headers['Authorization'] = 'Bearer ' + res.data.access_token;
        return Promise.resolve();
    }
}
createAuthRefreshInterceptor(axios, refreshAuthLogic, {statusCodes: [ 401, 403 ], skipWhileRefreshing: false});

export default axios;
